import { render, staticRenderFns } from "./HistoryButton.vue?vue&type=template&id=3dbd08a6"
import script from "./HistoryButton.vue?vue&type=script&lang=ts"
export * from "./HistoryButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports